import React, { useEffect, useState } from 'react';
import API_BASE_URL from "Components/API";
import Loading from "Components/Loading";
import { useTranslation } from "react-i18next";
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "Assets/icons/chevronRight.svg";
import axios from 'axios';
import parse from 'html-react-parser';
import Orgszineition from "Assets/icons/orgszineition.svg"
import LogoGray from "Assets/icons/logo-gray.svg"

const OrganizationChart = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;

    return (
        <div className="megaMenuContent">
            <div className="row h-100">
                <div className="col-8 pt-5">
                    <img
                        src={Orgszineition}
                        className="mx-auto max-width-100"
                        alt={t('organizational_structure')}
                    />
                </div>
                <div className="col-4 d-flex justify-content-center align-items-center">
                    <img
                        src={LogoGray}
                        className="mx-auto max-width-100"
                        alt={t('energy_exchange')}
                    />
                </div>
               
                <div className="col-12 text-start mt-2 align-self-end">
                    <a href="/OrganizationChart" target="_blank" className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1" >
                        {t('view_energy_exchange_structure')}
                        <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                            {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}
                        </span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default OrganizationChart;
